import React from 'react';

import Actions from './Actions';

const columns = [
  {
    name: 'Content',
    selector: 'attributes.body',
    wrap: true,
  },
  {
    name: 'Date',
    selector: 'attributes.date',
    cell: (row) => new Date(row.attributes.date).toLocaleDateString('en-US'),
    sortable: true,
    width: '140px',
  },
  {
    name: 'Actions',
    sortable: false,
    width: '100px',
    right: true,
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
